







































import { Component,  Prop, Watch } from "vue-property-decorator";
import { WorkshopModel, UserSearchModel } from "@/core/models";
import AppVue from "@/AppVue.vue";
import { WorkshopService, UserService } from "@/core/services";

@Component({
  components: {},
})
export default class WorkshopFacilitatorUpdateCpt extends AppVue {
  @Prop() model: WorkshopModel;

  hasEditedFacilitator = false;
  isEditingFacilitator = false;
  selectedFacilitator = UserService.getNoneUser();
  loading = false;

  @Watch("model")
  onModelChanged(val: WorkshopModel, oldVal: WorkshopModel) {
    this.setNewSelectedFacilitator(val.facilitatorId, val.facilitatorName);
  }

  private clearSelectedFacilitator() {
    this.selectedFacilitator = UserService.getNoneUser();
    this.selectedFacilitator.fullName = "";
  }

  private startEditingFacilitator() {
    this.setNewSelectedFacilitator(this.model.facilitatorId, this.model.facilitatorName);
    this.isEditingFacilitator = true;
  }

  private setNewSelectedFacilitator(userId: number, fullName: string) {
    this.setSelectedFacilitator({
      userId,
      fullName,
      email: "",
    });
  }

  private setSelectedFacilitator(facilitator: UserSearchModel) {
    this.selectedFacilitator = facilitator;
  }

  private selectFacilitator(facilitator: UserSearchModel) {
    this.setSelectedFacilitator(facilitator);
    this.hasEditedFacilitator = true;
  }

  private async save() {
    this.loading = true;
    try {
      const model = await WorkshopService.updateFacilitator(this.model.id, this.selectedFacilitator.userId);
      this.$emit("facilitator-updated", model);
    } catch (err) {
      this.notify("Error", "Something went wrong while saving facilitator", "error");
    } finally {
      this.isEditingFacilitator = false;
      this.hasEditedFacilitator = false;
      this.loading = false;
    }
  }

  private cancel() {
    this.isEditingFacilitator = false;
    this.hasEditedFacilitator = false;
  }

  private async findFacilitatorAsync(queryString: string, cb: (result: UserSearchModel[]) => void) {
    if (!queryString || queryString.length <= 2) {
      cb([UserService.getNoneUser()]);
      return;
    }

    this.loading = true;
    try {
      const users = await UserService.searchImiUsersAsync(queryString);
      users.unshift(UserService.getNoneUser());
      cb(users);
    } catch (err) {
      this.notify("Error", "Something went wrong while searching facilitator", "error");
    } finally {
      this.loading = false;
    }
  }
}
